//bao migrate skip
// bao migrate - module not found: import BaoMenuItem from "interfaces/bao/bao-menu-item";
import template from "./bao-toolbar2.html";
// bao migrate - module not found: import "services/bao-template-engine";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
Bao.Templates.baoToolbar = template;
function LoadButtons(url, formName, toolbarName, applicationId) {
    return Bao.post(url, JSON.stringify({ formName: formName, toolbarName: toolbarName ? toolbarName : null, applicationId: applicationId ? applicationId : null }));
}
function InitButtons(buttons: KnockoutObservableArray<Interfaces.Bao.BaoMenuItem>, element, clickHandler, enableButton, showButton, loaded, viewModel, bindingContext) {
    var documentClick = function () {
        if (toolbarVM.ignoreClick == false) {
            toolbarVM.ContainerVisible(false);
        }
        else {
            toolbarVM.ignoreClick = false;
        }
    };
    $(document).on("click", documentClick);
    ko.utils.domNodeDisposal.addDisposeCallback(element, () => {
        $(document).off("click", documentClick);
    });
    var toolbarVM = {
        ignoreClick: false,
        Buttons: buttons,
        ButtonClick: function (item: Interfaces.Bao.BaoMenuItem, args) {
            toolbarVM.ContainerVisible(false);
            if (toolbarVM.TargetUrlHasValidHref(item.TargetUrl)) {
                return true;
            }
            if (ko.unwrap(item.Enabled) == true) {
                clickHandler(item, args);
            }
        },
        TargetUrlHasValidHref: function (targetUrl: string | KnockoutObservable<string>): boolean {
            targetUrl = ko.unwrap(targetUrl);
            return targetUrl && (targetUrl.startsWith('#') || targetUrl.startsWith('https://') || targetUrl.startsWith('http://'));
        },
        TargetUrlsTarget: function (targetUrl: string | KnockoutObservable<string>): string {
            targetUrl = ko.unwrap(targetUrl);
            if (targetUrl && (targetUrl.startsWith('https://') || targetUrl.startsWith('http://'))) {
                return "_blank";
            }
            return "_self";
        },
        ContainerClick: function (item: Interfaces.Bao.BaoMenuContainer, args: Event) {
            if (ko.unwrap(item.Enabled) == true) {
                var itemsObs = <KnockoutObservableArray<Interfaces.Bao.BaoMenuButton>>(item.Items);
                toolbarVM.ContainerItems(itemsObs());
                toolbarVM.ContainerVisible(!toolbarVM.ContainerVisible());
                var $e = $(toolbarVM.ContainerElement());
                var offsetLeft = $(args.target["parentElement"]).offset().left - $(args.target["parentElement"].parentElement.parentElement).offset().left;
                $e.css("bottom", $e.height() * -1);
                $e.css("left", offsetLeft);
                toolbarVM.ignoreClick = true;
            }
            else {
                toolbarVM.ContainerVisible(false);
            }
        },
        ContainerVisible: ko.observable(false),
        ContainerElement: ko.observable<HTMLElement>(),
        ContainerItems: ko.observableArray<Interfaces.Bao.BaoMenuButton>()
    };
    if (enableButton != null && typeof enableButton === 'string') {
        viewModel[enableButton] = function (actionKey, enable) {
            if (actionKey != null && enable != null) {
                ko.utils.arrayForEach(buttons(), function (btn) {
                    toggleButtonState(btn, enable, actionKey, "Enabled");
                });
            }
        };
    }
    if (showButton != null && typeof showButton === 'string') {
        viewModel[showButton] = function (actionKey, show) {
            if (actionKey != null && show != null) {
                ko.utils.arrayForEach(buttons(), function (btn) {
                    toggleButtonState(btn, show, actionKey, "Visible");
                });
            }
        };
    }
    if ($.isFunction(loaded)) {
        loaded(buttons);
    }
    $(element).append(Bao.Templates.baoToolbar);
    var childContext = bindingContext.createChildContext(toolbarVM);
    ko.applyBindingsToDescendants(childContext, element);
}
;
function toggleButtonState(button, state, actionKey, property: "Enabled" | "Visible") {
    // Check if the button is a container
    if (ko.unwrap((button as Interfaces.Bao.BaoMenuContainer).Items)?.length > 0) {
        ko.utils.arrayForEach(ko.unwrap((button as Interfaces.Bao.BaoMenuContainer).Items), function (nestedButton) {
            toggleButtonState(nestedButton, state, actionKey, property);
        });
    }
    // The button is a regular button; toggle visibility
    if (ko.unwrap(button.ActionKey) === actionKey) {
        var obs = <KnockoutObservable<boolean>>(button[property]);
        obs(state);
    }
}
var baoToolbarBinding: KnockoutBindingHandler = {};
baoToolbarBinding.init = (element: any, valueAccessor: () => any, allBindingsAccessor: KnockoutAllBindingsAccessor, viewModel: any, bindingContext: KnockoutBindingContext) => {
    var config: Bindings.baoToolbar2 = ko.utils.unwrapObservable(valueAccessor());
    var toolbarName = ko.unwrap(config.toolbarName);
    var applicationId = ko.unwrap(config.applicationId);
    var formName = ko.unwrap(config.formName);
    var clickHandler = config.click;
    var enableButton = config.enable;
    var showButton = config.show;
    var loaded = config.loaded;
    var buttons: KnockoutObservableArray<Interfaces.Bao.BaoMenuItem> = config.buttons;
    var url = "Bao/LoadBootstrapToolbar";
    if (formName == null || formName == "") {
        InitButtons(buttons, element, clickHandler, enableButton, showButton, loaded, viewModel, bindingContext);
    }
    else {
        LoadButtons(url, formName, toolbarName, applicationId).then((returnValue: Interfaces.Bao.BaoMenuItem[]) => {
            if (buttons == null || ko.isObservable(buttons) == false) {
                buttons = ko.observableArray<Interfaces.Bao.BaoMenuItem>([]);
            }
            ko.map.fromJS(returnValue, buttons);
            InitButtons(buttons, element, clickHandler, enableButton, showButton, loaded, viewModel, bindingContext);
        });
    }
    return { controlsDescendantBindings: true };
};
ko.bindingHandlers["baoToolbar"] = baoToolbarBinding;
ko.bindingHandlers["baoToolbar2"] = baoToolbarBinding;